
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.25.03H.5a.5.5 0 00-.5.5v23a.5.5 0 00.5.5h5.75a.5.5 0 00.5-.5v-23a.5.5 0 00-.5-.5zM1 7.48l4.04 4.05H1zm4.75 3.34L1.71 6.78h4.04zM1 12.52h4.75v4.76H1zm0-11.5h4.75v4.76H1zm4.75 22H1v-4.74h4.75zm17.72-9.76H21.2l-.03-.93a1.19 1.19 0 00-1.1-1.26h-3.23a1.18 1.18 0 00-1.1 1.24l-.03.95h-2.25a.5.5 0 000 1h.71l.53 8.38a1.4 1.4 0 001.37 1.43h4.77a1.4 1.4 0 001.37-1.4l.54-8.41h.7a.5.5 0 000-1zm-6.71-.93a.34.34 0 01.1-.26h3.22a.33.33 0 01.1.27l.03.92h-3.48zm4.47 10.32a.4.4 0 01-.38.42h-4.77a.42.42 0 01-.37-.46l-.53-8.35h6.57z"}}),_c('path',{attrs:{"d":"M16.51 15.54a.25.25 0 00-.23.26l.34 6.06a.25.25 0 00.25.24h.01a.25.25 0 00.24-.27l-.34-6.06a.24.24 0 00-.27-.23zm1.67 2.02a.25.25 0 00-.24.26l.2 4.04a.25.25 0 00.24.24h.02a.25.25 0 00.24-.26l-.2-4.04a.24.24 0 00-.26-.24zM15 8.51h-1.18a.5.5 0 100 1h2.39a.5.5 0 00.5-.5V6.63a.5.5 0 00-1 0V7.8l-.61-.61a4.8 4.8 0 00-3.36-1.42 4.47 4.47 0 00-3.35 1.35.5.5 0 00.71.71 3.75 3.75 0 015.3.06z"}})])
          )
        }
      }
    